import React, { useEffect } from 'react';
import Lottie from 'lottie-react';
import './LottieAnimation.css';
interface LottieAnimationProps {
  url?: string; // Ya no es necesario, pero mantenemos para compatibilidad
}
const LottieAnimation: React.FC<LottieAnimationProps> = ({ url }) => {
  const [animationData, setAnimationData] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);
  useEffect(() => {
    const fetchAnimation = async () => {
      // Usar directamente el proxy del backend para evitar problemas de CORS
      try {
        // Normalizar la URL base para evitar duplicación de /api
        let backendUrl = process.env.REACT_APP_API_URL || '/api';
        backendUrl = backendUrl.replace(/\/api\/?$/, '');
        const proxyUrl = `${backendUrl}/api/lottie-animation`;
        const response = await fetch(proxyUrl, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
          },
          credentials: 'include',
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setAnimationData(data);
        setLoading(false);
        setError(null);
      } catch (proxyError) {
        const errorMessage = proxyError instanceof Error ? proxyError.message : 'Error desconocido';
        setError(errorMessage);
        setLoading(false);
      }
    };
    fetchAnimation();
  }, []);
  if (loading) {
    return (
      <div className="lottie-container">
        <div className="lottie-loading">Cargando animación...</div>
      </div>
    );
  }
  if (error || !animationData) {
    return (
      <div className="lottie-container">
        <div className="lottie-error">
          <div>No se pudo cargar la animación</div>
          {error && (
            <div style={{ 
              fontSize: '12px', 
              marginTop: '8px', 
              color: '#94a3b8',
              fontFamily: "'Montserrat', sans-serif"
            }}>
              {error}
            </div>
          )}
        </div>
      </div>
    );
  }
  return (
    <div className="lottie-container">
      <Lottie 
        animationData={animationData} 
        loop={true}
        autoplay={true}
        className="lottie-animation"
        style={{
          width: '100%',
          height: '100%',
          maxWidth: '100%',
          maxHeight: '600px'
        }}
      />
    </div>
  );
};
export default LottieAnimation;
